import { GridColDef, GridRenderCellParams, gridRowNodeSelector } from '@mui/x-data-grid-premium';
import { ConditionsNew } from '@retail/calculus/types';
import { AppTFunction } from '@retail/app/i18n';

export const baseColumnProps: Partial<GridColDef<ConditionsNew>> = {
  sortable: false,
  headerAlign: 'left',
  align: 'left',
  disableColumnMenu: true,
};

export const getFreightText = (condition: ConditionsNew, t: AppTFunction): string => {
  if (condition.freightCondition?.percentAddon) {
    return `${condition.freightCondition.percentAddon}%`;
  }
  if (condition.freightCondition?.fixedAddOn) {
    return t('freight.columns.pricePerUnit', {
      price: condition.freightCondition.fixedAddOn,
      unit: condition.freightCondition.fixedAddOnUnit,
    });
  }
  return '';
};

const getRowFromNode = (
  params: GridRenderCellParams<ConditionsNew>,
  id: GridRenderCellParams['id']
): ConditionsNew | undefined => params.api.getRow<ConditionsNew>(id) ?? undefined;

// Follows the first child down to a real condition — used to label an auto-generated
// supplier node (a supplier with sub-conditions but no supplier-level condition).
export const getDescendantCondition = (
  params: GridRenderCellParams<ConditionsNew>
): ConditionsNew | undefined => {
  if (params.rowNode.type !== 'group') return undefined;
  const apiRef = { current: params.api };
  let childId = params.rowNode.children[0];
  while (childId != null) {
    const childNode = gridRowNodeSelector(apiRef, childId);
    if (childNode.type === 'group' && childNode.isAutoGenerated) {
      childId = childNode.children[0];
      continue;
    }
    return getRowFromNode(params, childId);
  }
  return undefined;
};

export const resolveCondition = (
  params: GridRenderCellParams<ConditionsNew>
): ConditionsNew | undefined => {
  if (params.rowNode.type === 'group' && params.rowNode.isAutoGenerated) return undefined;
  return params.row;
};
